module.exports = __webpack_public_path__ + "img/yhdista-lainasi.3d628cb.jpg";